import {Alert, Snackbar} from "@mui/material";
import useDrive from "../../hooks/useDrive";
import AppLinearProgressWithLabel from "../AppProgressBar";
import {UPLOAD_STATUS} from "../../config/appConst";
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import styles from "./file-upload.module.js.css";

export default function ProgressSnack(props) {

    const {uploadStatus} = useDrive();
    const [value, setValue] = useState(0);

    //     useEffect(() => {
    //     const timer = setInterval(() => {
    //         setValue((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
    //     }, 800);
    //     return () => {
    //         clearInterval(timer);
    //     };
    // }, []);
    useEffect(() => {
        // console.log(props.value);
        setValue(Math.round(
            props.value,
        ));
    }, [props.value])
    const isOpen = () => {
        return uploadStatus === UPLOAD_STATUS.UPLOADING && props.fileDetail && props.fileDetail.file_name;
    }
    return <div>
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal:'center' }}
            open={isOpen()}
        >
            <Box sx={{ backgroundColor: '#8c3b61', p: 1, borderRadius: 2, borderColor: "primary.dark", color: "#fefefe", width: '100%'}}>
                <div style={{width: "300px"}}><p className={styles.fileName}>Uploading {props.fileDetail && props.fileDetail.file_name ? props.fileDetail.file_name : ''}...</p>
                    <AppLinearProgressWithLabel value={value} style={{width: "95%"}}/></div>
            </Box>
        </Snackbar>
    </div>
}